import React, { useState }  from "react";
import { Carousel } from "react-responsive-carousel";
import "react-responsive-carousel/lib/styles/carousel.min.css";
import uniformeInicial3 from "../../../assets/images/uniforme2.jpg";
import uniformeInicial4 from "../../../assets/images/uniforme1.jpg";
import uniformeInicial from "../../../assets/images/uniformes/uniformePrimario.png"; // Asegúrate de tener estos
import uniformeInicialEF from "../../../assets/images/uniformes/uniformePrimarioEF.png";

import uniformeInicial6 from "../../../assets/images/uniforme6.jpg";
import uniformeInicial7 from "../../../assets/images/uniforme7.png";
import uniformeInicial8 from "../../../assets/images/uniforme8.jpg.png";

import Button from 'react-bootstrap/Button';
import { Container, Row, Col, Card, Nav } from "react-bootstrap";
//import pdfUniforme from "nuevoUniforme.pdf";  Archivo PDF de ejemplo

function Uniforms() {
   const [nivelSeleccionado, setNivelSeleccionado] = useState("Nivel Inicial");

  const secciones = [
    {
      id: "Nivel Inicial",
      title: "Nivel Inicial",
      description: [
        "Delantal a cuadritos verde y blanco con cuello verde y escudo del Colegio. Medias verdes, zapatos negros o marrones.",
        "Educación física: Verano: short, remera, medias y zapatillas blancas. Invierno: joggins verde y zapatillas blancas."
      ],
      images: [uniformeInicial, uniformeInicialEF]
    },
    {
      id: "Primario Varones",
      title: "Nivel Primario: Varones",
      description: [
        "Verano: Bermuda gris, camisa o chomba blanca, medias verdes y zapatos negros o marrones.",
        "Invierno: pantalón gris, camisa blanca, pullover o cardigan verde oscuro. Campera de polar verde oscuro. Zapatos negros o marrones.",
        "Educación física: Verano: short, remera, medias y zapatillas blancas. Invierno: joggins verde y zapatillas blancas."
      ],
      images: [uniformeInicial4, uniformeInicial6]
    },
    {
      id: "Primario Mujeres",
      title: "Nivel Primario: Mujeres",
      description: [
        "Verano: jumper cuadrillé blanco y verde, camisa blanca con volado verde. Medias verdes, zapatos marrones o negros.",
        "Invierno: jumper escocés, camisa blanca con volado verde. Pullover o cardigan verde oscuro. Campera de polar verde oscuro. Medias verdes, zapatos marrones o negros.",
        "Educación física: Verano: short, remera, medias y zapatillas blancas. Invierno: joggins verde y zapatillas blancas."
      ],
      images: [uniformeInicial7]
    },
    {
      id: "Secundario",
      title: "Nivel Secundario",
      description: [
        "Mujeres: Verano: Pollera escocesa, chomba blanca con vivos amarillo y verde. Medias verdes, zapatos negros o marrones.",
        "Invierno: Pollera escocesa, camisa blanca, corbata verde, pullover escote en V o cardigan verde, campera de polar verde.",
        "Varones: Verano: Pantalón largo gris, chomba blanca con vivos amarillo y verde. Medias verdes y zapatos negros o marrones.",
        "Invierno: Pantalón gris, camisa blanca, corbata verde, pullover o cardigan verde y campera de polar verde.",
        "Educación física: Idem mujeres."
      ],
      images: [uniformeInicial8]
    },
  ];

  const seccionActual = secciones.find(sec => sec.id === nivelSeleccionado);

  return (
    <section className="max-w-7xl mx-auto px-4 md:px-6 py-16 font-serif text-black bg-gradient-to-br from-[#e9f5f1] to-white">
      <Container>
        {/* Título */}
        <div className="text-center mb-4">
          <h1 className="text-5xl font-extrabold text-[#294235] mb-2">Uniformes Escolares</h1>
          <p className="text-gray-700 text-lg">
            Conocé los uniformes correspondientes según edad y género.
          </p>
          <a href="/planillas/nuevoUniforme.pdf" download className="mt-4 d-inline-block">
            <Button variant="success">Descargar PDF</Button>
          </a>
        </div>

        {/* Tabs Bootstrap */}
        <Nav
          variant="pills"
          activeKey={nivelSeleccionado}
          onSelect={(k) => setNivelSeleccionado(k)}
          className="justify-content-center flex-wrap gap-2 mb-4"
        >
          {secciones.map((sec) => (
            <Nav.Item key={sec.id}>
              <Nav.Link eventKey={sec.id} className="rounded-pill px-4 py-2">
                {sec.id}
              </Nav.Link>
            </Nav.Item>
          ))}
        </Nav>

        {/* Descripciones del nivel seleccionado */}
        <Row className="justify-content-center">
          <Col lg={10}>
            <ul className="mb-3">
              {seccionActual.description.map((txt, i) => (
                <li key={i} className="mb-1">{txt}</li>
              ))}
            </ul>
          </Col>
        </Row>

        {/* Grid de imágenes con Bootstrap */}
        <Row xs={1} sm={2} md={3} lg={4} className="g-3 justify-content-center mt-2">
          {seccionActual.images.map((img, idx) => (
            <Col key={idx} className="d-flex">
              <Card className="border-0 bg-transparent mx-auto">
                <Card.Img
                  src={img}
                  alt={`Uniforme ${idx + 1}`}
                  className="img-thumbnail"
                  style={{ width: "240px", height: "240px", objectFit: "cover" }}
                />
                {/* <Card.Body className="p-2 text-center small text-muted">Uniforme {idx + 1}</Card.Body> */}
              </Card>
            </Col>
          ))}
        </Row>
      </Container>
    </section>
  )
}

export default Uniforms;
